export default "__VITE_ASSET__D1Kje6ZB__"